export default __webpack_public_path__ + "static/media/1302.02ab4245.png";